export default __webpack_public_path__ + "static/media/logomatchmaking.ab02f0c1.png";